var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutdoors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5078 156.608C86.9559 148.553 93.2814 132.426 106.902 121.948C114.665 115.975 127.25 112.258 134.835 104.964C136.453 103.408 148.9 88.9558 151.054 90.0601C156.643 92.9266 171.322 117.436 176.734 123.681",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.582 138.101C165.51 137.36 171.571 133.964 173.725 133.523C177.252 132.8 179.049 128.236 183.772 129.618C189.077 131.172 188.668 139.848 191.393 143.106C193.836 146.025 200.258 146.753 203.518 149.139C210.237 154.056 212.949 164.126 218.761 170.08C229.033 180.604 239.206 190.53 248.554 202.023",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.995 96.0554C158.131 110.597 134.361 128.147 132.223 139.452",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.082 152.404C215.614 148.184 229.151 125.771 236.437 129.854C241.992 132.967 242.212 142.376 248.067 145.041C258.486 149.783 260.481 142.433 271.795 153.877C276.969 159.11 296.605 182.301 303.29 183.823C306.552 184.565 308.262 181.465 311.487 182.841C315.281 184.46 321.702 195.968 330.493 195.968",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5078 202.845C105.588 198.358 136.126 212.991 167.432 228.586C172.703 231.212 190.915 238.602 186.024 246.065C179.222 256.441 44.4927 260.242 111.066 271.886C177.639 283.529 92.1096 287.609 69.5078 309",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.288 174.774C140.11 190.629 139.858 211.635 140.288 225.235",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.446 212.5C143.783 213.104 135.753 215.205 128.18 214.113",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.598 202.19C143.336 202.097 135.035 202.309 131.742 202.408",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.8 190.874C141.584 190.668 138.34 190.682 135.066 190.634",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.713 181.795C140.863 182.025 139.972 181.883 139.102 181.927",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.023 165.691C116.844 181.546 116.592 202.552 117.023 216.152",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.18 203.417C120.517 204.021 112.487 206.121 104.914 205.03",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.329 193.107C120.066 193.015 111.766 193.226 108.473 193.325",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.531 181.791C118.314 181.584 115.07 181.599 111.797 181.55",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.447 172.712C117.597 172.942 116.707 172.8 115.836 172.844",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.754 234.899C218.142 237.028 294.764 230.262 330.489 235.083",
    stroke: "#FFF",
    strokeOpacity: 0.9,
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoors);
export default __webpack_public_path__ + "static/media/outdoors.e86b1e6e00c561edb552300cd33dca75.svg";
export { ForwardRef as ReactComponent };